import React from "react";
import S from './DropdownDivider.module.scss';

export function DropdownDivider() {
  return <div className={S.root} />;
}
